import { render, staticRenderFns } from "./DashUsers.vue?vue&type=template&id=1b722919&scoped=true"
import script from "./DashUsers.vue?vue&type=script&lang=js"
export * from "./DashUsers.vue?vue&type=script&lang=js"
import style0 from "./DashUsers.vue?vue&type=style&index=0&id=1b722919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b722919",
  null
  
)

export default component.exports